<template>
  <nav class="mobile-back-bar is-flex is-align-items-center is-justify-content-space-between">
    <div class="bar-side-container">
      <div class="clickable-icon" @click="goBack" role="button" aria-label="Go back">
        <b-icon pack="fas" icon="chevron-left" size="is-medium" />
      </div>
    </div>

    <!-- Not an h1: the page itself has the main heading -->
    <p class="page-title">{{ routeNameHumanized }}</p>

    <div class="bar-side-container is-justify-content-end">
      <div v-if="hasShareOption" class="share-wrapper">
        <div class="clickable-icon" @click="toggleShareContainer" role="button" aria-label="Share">
          <b-icon pack="fas" icon="share-alt" size="is-small" />
        </div>
        
        <transition name="fade">
          <div v-if="showShareContainer" class="share-dropdown-overlay">
            <SocialSharing :url="url" :title="title" @close="showShareContainer = false" />
          </div>
        </transition>
      </div>
    </div>
  </nav>
</template>

<script>
import SocialSharing from "../../Blog/SocialSharing.vue";
export default {
  components: { SocialSharing },
  props: {
    routeName: { type: String, default: null },
    routeNameHumanized: { type: String, default: "" },
    hasShareOption: { type: Boolean, default: false },
    title: { type: String, default: "" },
    url: { type: String, default: "" },
  },
  data() {
    return { showShareContainer: false };
  },
  methods: {
    goBack() {
      this.$emit("on-leave");
      if (this.routeName) {
        this.$router.push({ name: this.routeName });
        return;
      }
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: "home" });
    },
    toggleShareContainer() {
      this.showShareContainer = !this.showShareContainer;
    }
  },
};
</script>

<style lang="scss" scoped>
.mobile-back-bar {
  height: 56px; /* Standard Mobile AppBar height */
  background-color: transparent;
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
}

.bar-side-container {
  display: flex;
  align-items: center;
  flex: 1; /* Ensures left/right take equal space to keep title centered */
  z-index: 2;
}

.page-title {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  margin: 0 auto;
  font-family: "Inter", sans-serif;
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--primary);
  pointer-events: none; /* Allows clicks to pass through to buttons if they overlap */
  z-index: 1;
}

.clickable-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  cursor: pointer;
  color: var(--primary);
  transition: opacity 0.2s ease;
  border-radius: 50%;

  &:active {
    background-color: rgba(0, 0, 0, 0.05); /* Native "tap" feedback */
    opacity: 0.7;
  }
}

.share-wrapper {
  position: relative;
}

.share-dropdown-overlay {
  position: absolute;
  top: 45px;
  right: 0;
  background: white;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  border-radius: 8px;
  padding: 10px;
  min-width: 150px;
}

/* Animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>